<template>
  <div class="app">
    <!-- :style="isEmulated ? 'background: #FFEBEB !important;':''" -->
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/">
        <img
          class="navbar-brand-full"
          src="../assets/aai-logo-icon-30x30.png"
          width="30"
          height="29"
          alt="AAI"
        />
        <img
          class="navbar-brand-minimized"
          src="../assets/aai-logo-icon-30x30.png"
          width="30"
          height="29"
          alt="AAI"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        <span style="font-size:18px;">
          {{isDistributor ? isEmulated ? 'Client:' : 'Distributor: ':''}}
          <strong>{{ getCompanyName }}</strong>
        </span>
        <span v-if="!isEmulated">
          <i class="cui-arrow-right icons font-1xl d-block mt-4 name-spacer" />
        </span>
        <b-nav-item v-if="!isEmulated" class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item v-if="!isEmulated" class="px-3" to="/packages" exact>Packages</b-nav-item>
        <b-nav-item v-if="!isEmulated" class="px-3" to="/settings">Settings</b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-nav-item class="d-md-down-none">
          <!-- <DefaultHeaderDropdownNotif/> -->
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <!-- <DefaultHeaderDropdownTasks/> -->
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <!-- <DefaultHeaderDropdownMssgs/> -->
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <!-- <DefaultHeaderDropdown/> -->
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <el-input
            placeholder="Search by name..."
            v-model="search"
            @keyup.enter.native="searchByName"
          ></el-input>
        </b-nav-item>
        <b-nav-item v-if="showLanguages" class="d-md-down-none">
          <header-language-dropdown />
        </b-nav-item>
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <!--  :style="isEmulated ? 'background: #057AB3 !important;':''" -->
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view ref="parentScroll"></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://aai-live.com" target="_blank">AAI-Live</a> |
        <a href="https://aai-assessment.com" target="_blank">AAI Website</a> |
        <a href="https://careerliftoff.com" target="_blank">CLII Website</a>
      </div>
      <div class="ml-auto">
        <span class="ml-1">&copy; 2019 Assessment Associates International.</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import nav from '@/_nav';
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from '@coreui/vue';
import DefaultAside from './DefaultAside';
import DefaultHeaderDropdown from './DefaultHeaderDropdown';
import DefaultHeaderDropdownNotif from './DefaultHeaderDropdownNotif';
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt';
import DefaultHeaderDropdownMssgs from './DefaultHeaderDropdownMssgs';
import DefaultHeaderDropdownTasks from './DefaultHeaderDropdownTasks';
import HeaderLanguageDropdown from './HeaderLanguageDropdown.vue';
import axios from '../shared/axios';

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    DefaultHeaderDropdownMssgs,
    DefaultHeaderDropdownNotif,
    DefaultHeaderDropdownTasks,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    HeaderLanguageDropdown
  },
  data() {
    return {
      nav: nav.items,
      enableTop5: false,
      showLanguages: false,
      search: ''
    };
  },
  computed: {
    ...mapGetters('auth', [
      'getCompanyName',
      'getDistributorName',
      'isDistributor',
      'isEmulated',
      'is360Enabled'
    ]),
    ...mapGetters('packages', ['getPackageList', 'getPackageNameById']),
    ...mapGetters('settings', ['getEnabledPackages', 'getEnabledImportWizard']),
    name() {
      return this.$route.name;
    },
    list() {
      // console.log(this.$route.name);
      let defaultList = this.$route.matched.filter(
        route => route.name || route.meta.label
      );
      // console.log(defaultList);
      if (this.$route.name === 'Viewing Package') {
        if (this.$route.params.packageId) {
          const packageId = parseInt(this.$route.params.packageId, 0);
          // console.log(packageId);
          const packageName = this.getPackageNameById(packageId);
          // console.log(packageName);
          if (packageName !== undefined)
            defaultList.push({ name: packageName, path: '' });
        }
      }
      return defaultList;
    }
  },
  async created() {
    // TODO: create a switch, between last 5 packages/test-takers
    const pl = Object.assign([], this.getPackageList);
    pl.sort(function(a, b) {
      return new Date(b.date_assigned) - new Date(a.date_assigned);
    });
    if (this.enableTop5 === true) {
      const topFive = pl.splice(0, 5);
      for (var inc in topFive) {
        this.nav.push({
          name: topFive[inc].block_name,
          url: '',
          icon: 'fa fa-archive',
          label: {
            variant: 'info' // 'danger'
          }
        });
      }
    }
    // Get Settings
    const b = await this.fetchClientSettings();
    if (this.getEnabledImportWizard || this.isDistributor) {
      const obj = Object.assign([], this.nav);
      obj.splice(3, 0, {
        name: 'Email Import',
        url: '/package/import/email',
        icon: 'fa fa-envelope'
      });
      this.nav = Object.assign([], obj);
      this.$forceUpdate();
    }
    if (this.getEnabledPackages || this.isDistributor) {
      const obj = Object.assign([], this.nav);
      obj.splice(3, 0, {
        name: 'New Package',
        url: '/package/add',
        icon: 'fa fa-plus-square-o'
      });
      this.nav = Object.assign([], obj);
      this.$forceUpdate();
    }
    if (this.isDistributor && !this.isEmulated) {
      const obj = Object.assign([], this.nav);
      obj.splice(1, 0, {
        name: 'List Clients',
        url: '/client/list',
        icon: 'fa fa-list'
      });
      obj.splice(1, 0, {
        name: 'Add Client',
        url: '/client/add',
        icon: 'fa fa-list'
      });
      this.nav = Object.assign([], obj);
      this.$forceUpdate();

      if (this.is360Enabled) {
        obj.splice(7, 0, {
          title: true,
          name: '360',
          class: '',
          wrapper: {
            element: '',
            attributes: {}
          }
        });
        obj.splice(8, 0, {
          name: 'New Distribution',
          url: '/360/new',
          icon: 'fa fa-plus-circle'
        });
        obj.splice(9, 0, {
          name: "Build Reports",
          url: '/360/build',
          icon: 'fa fa-plus'
        });
        obj.splice(9, 0, {
          name: "List Reports",
          url: '/360/reports',
          icon: 'far fa-newspaper'
        });
        obj.splice(9, 0, {
          name: "List Groups",
          url: '/360/list',
          icon: 'fa fa-users'
        });
        this.nav = Object.assign([], obj);
        this.$forceUpdate();
      }
    }
    if (this.isEmulated) {
      const obj = Object.assign([], this.nav);
      obj.splice(1, 0, {
        name: 'Exit Client',
        url: '/client/exit',
        icon: 'fa fa-times',
        class: 'btn-warning' //
      });
      this.nav = Object.assign([], obj);
      this.$forceUpdate();
    }
  },
  methods: {
    ...mapActions('settings', ['fetchClientSettings']),
    ...mapActions('auth', ['emulate']),
    searchByName() {
      this.$router.push('/search/' + this.search);
    },
    resetEmulation() {
      axios.get('client/reset/emulation').then(r => {
        this.emulate(r.data);
        location.href = '/dashboard';
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.name-spacer {
  margin-top: 0px !important;
  margin-left: 20px;
}
</style>
